<template>
    <div class="user-chart"></div>
</template>

<script>
export default {
    data: function () {
        return {}
    },
    props: [
        "chartData"
    ],
    mounted() {
        
    },
    watch: {
        chartData: function () {
            if (this.chartData) {
                this.createChartData(); 
            }
        }
    },
    methods: {
        // Create the chart object
        createChartData() {
            var myChart = this.$echarts.init(this.$el);

            var option = {
                tooltip: {
                    axisPointer: {
                        type: 'cross'
                    },
                    trigger: 'axis'
                },
                backgroundColor: "#2a2d2e",
                textStyle: {
                    color: "#a8a7a9"
                },
                dataZoom: [{
                    type: "inside",

                }],
                xAxis: {
                    type: 'category',
                    data: this.chartData.time,
                    show: false,
                },
                yAxis: {
                    name: "收益",
                    type: "value",
                    show: false,
                    axisLabel: {
                        formatter: "{value} %"
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#5a595a'
                        }
                    }
                },
                series: {
                    type: "line",
                    name: "收益",
                    data: this.chartData.earnings,
                    symbol: 'none',
                    lineStyle: {
                        width: 1,
                        // colorStops: [{
                        //     offset: 0, color: "rgba(175, 52, 49, 0.2)"
                        // }, {
                        //     offset: 1, color: "rgba(175, 52, 49, 0.5)"
                        // }]
                    },
                    // itemStyle: {
                    //     normal: {
                    //         lineStyle: {
                    //             color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    //                 offset: 0, color: "green"
                    //             }, {
                    //                 offset: 1, color: "red"
                    //             }])
                    //         }
                    //     }
                    // }
                },
            };

            myChart.setOption(option);
            
        }

    }
}
</script>

<style lang="scss" scoped>
.user-chart {
    width: 300px;
    height: 250px;
}
</style>

